var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 32",
    style: {
      enableBackground: "new 0 0 19 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9E9E9E;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,0H3.5C1.5,0,0,1.8,0,4v24c0,2.2,1.5,4,3.5,4h12.1c1.9,0,3.5-1.8,3.5-4V4C19,1.8,17.5,0,15.5,0z M17.3,28 c0,1.1-0.8,2-1.7,2H3.5c-1,0-1.7-0.9-1.7-2V4c0-1.1,0.8-2,1.7-2h12.1c1,0,1.7,0.9,1.7,2V28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,5h3.5c0.5,0,0.9-0.4,0.9-1s-0.4-1-0.9-1H7.8C7.3,3,6.9,3.5,6.9,4S7.3,5,7.8,5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.5,29c0.7,0,1.3-0.7,1.3-1.5S10.2,26,9.5,26s-1.3,0.7-1.3,1.5S8.8,29,9.5,29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.365f8930bd478a04046f8c9139ad299e.svg";
export { ForwardRef as ReactComponent };